import { Show, useTable, useModal, useForm } from "@refinedev/antd";
import {
  Button,
  Form,
  Input,
  Modal,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import {
  errorNotification,
  successNotification,
} from "../../../helpers/notiffication.helper";
import { useNavigation } from "@refinedev/core";

type Segment = {
  id?: string | number;
  name: string;
  // fnl-10668: системный сегмент неавторизованных — состав берётся из
  // fcm_anon_token, поэтому списка пользователей у него нет и удалить его нельзя.
  isAnon?: boolean;
  // Размер сегмента: у обычного — пользователи, у системного — анонимные токены.
  membersCount?: number;
  // 12251: сколько установок сегмента уйдёт через Push API AppMetrica.
  appmetricaCount?: number;
};
export const SegmentsList = () => {
  const { tableProps } = useTable<Segment>({
    dataProviderName: "pushSegmentsDataProvider",
    resource: "push-segments",
    syncWithLocation: false,
    queryOptions: { enabled: true },
    ...errorNotification({}),
  });

  const { modalProps, show, close } = useModal();

  const { formProps, form } = useForm<{ name: string }>({
    action: "create",
    resource: "push-segments",
    dataProviderName: "pushSegmentsDataProvider",
    redirect: false,
    ...successNotification({
      successData: { message: "Сегмент создан", type: "success" },
      callback: () => {
        close();
        form.resetFields();
      },
    }),
    ...errorNotification({}),
  });

  const onAfterClose = () => form.resetFields();
  const { push } = useNavigation();

  return (
    <Show
      title={"Сегменты"}
      resource={"push-segments"}
      breadcrumb={false}
      headerButtons={<Button onClick={show}>Создать сегмент</Button>}
    >
      {tableProps.loading ? (
        <Spin />
      ) : (
        <Table<Segment>
          {...tableProps}
          rowKey={(r) => String(r.id ?? r.name)}
          pagination={false}
        >
          <Table.Column<Segment>
            title={"Название"}
            dataIndex={"name"}
            key={"name"}
            render={(value, record) =>
              record.isAnon ? (
                // Системный сегмент: не ведём на страницу пользователей — состав
                // формируется автоматически, добавлять и удалять там нечего.
                <Space>
                  <span>
                    {value} ({record.membersCount ?? 0}
                    {record.appmetricaCount
                      ? `, AM — ${record.appmetricaCount}`
                      : ""}
                    )
                  </span>
                  <Tooltip
                    title={
                      "Системный сегмент: все установки приложения без авторизации. " +
                      "В скобках — число анонимных токенов, пользователей у него нет; " +
                      "AM — сколько из них уйдёт через AppMetrica. " +
                      "Состав обновляется автоматически, удалить его нельзя."
                    }
                  >
                    <Tag color={"default"}>системный</Tag>
                  </Tooltip>
                </Space>
              ) : (
                <Button
                  type={"link"}
                  onClick={() => push(`/segments/${record.id}`)}
                  style={{ padding: 0 }}
                >
                  {value} ({record.membersCount ?? 0}
                  {record.appmetricaCount
                    ? `, AM — ${record.appmetricaCount}`
                    : ""}
                  )
                </Button>
              )
            }
          />
        </Table>
      )}
      <Modal
        {...modalProps}
        title={"Создание сегмента"}
        onCancel={close}
        afterClose={onAfterClose}
        footer={<></>}
      >
        <Form {...formProps} layout={"vertical"}>
          <Form.Item
            name={"name"}
            label={"Название сегмента"}
            rules={[
              { required: true, message: "Укажите название" },
              { min: 2, message: "Минимум 2 символа" },
            ]}
          >
            <Input placeholder={"Например: Активные пользователи"} />
          </Form.Item>
          <Space>
            <Button onClick={close}>Отмена</Button>
            <Button type={"primary"} htmlType={"submit"}>
              Создать
            </Button>
          </Space>
        </Form>
      </Modal>
    </Show>
  );
};
